<script setup lang="ts">
import type { NuxtError } from "#app";

const props = defineProps({
  error: Object as () => NuxtError,
});
</script>

<template>
  <NuxtLayout name="404">
    <main class="flex min-h-full items-center justify-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div class="text-center">
        <p class="text-8xl font-semibold text-indigo-600">
          {{ error.statusCode || 500 }}
        </p>
        <h1 class="mt-4 text-balance text-4xl font-semibold tracking-tight text-zinc-900 sm:text-6xl">
          {{ error.statusMessage || "An unexpected error occurred" }}
        </h1>
        <div v-if="error.statusCode === 404"
          class="mt-6 text-pretty text-lg font-medium text-zinc-500 sm:text-xl/8 max-w-xl mx-auto">
          The helpdesk you are trying to access does not exist. It might have
          been removed or relocated to a different domain.
        </div>
      </div>
    </main>
  </NuxtLayout>
</template>